import React, { useEffect } from "react";
import { IonPage, IonContent } from '@ionic/react';
import HomeSections from "../components/HomeSections/HomeSections";
import Footer from "../components/Footer";
import Header from "../components/Header";
import './Home.css'
import env from '../env.json'
import ReactGA from "react-ga4";
import axios from "axios";


// const PHP_PROXY_URL_HOME_SECTIONS = 'https://portal.mastinseguridad.com/apisapp/ga_proxy.php';

// const getOrCreateGaClientIdForHome = (): string => {
//   let clientId = localStorage.getItem('ga_client_id');
//   if (!clientId) {
//     clientId = typeof self !== 'undefined' && self.crypto?.randomUUID ? 
//                self.crypto.randomUUID() : 
//                `uuid-${Date.now()}-${Math.random().toString(36).substring(2)}`;
//     localStorage.setItem('ga_client_id', clientId);
//   }
//   return clientId;
// };

// const user = localStorage.getItem('profile') as string;
// const profile = user ? JSON.parse(user) : null;
// const userIdForGa = profile?.id?.toString() ?? undefined; 

// const clientIdForGa = getOrCreateGaClientIdForHome();

// const payloadToProxyHome = {
//   client_id: clientIdForGa,
//   user_id: userIdForGa, 
//   event_name: 'page_view', 
//   event_params: {         
//       page_location: '/pages/Home',
//       page_title: 'Home'
//   }
// };

// console.log('Enviando page_view inicial a proxy GA:', payloadToProxyHome);
// fetch(PHP_PROXY_URL_HOME_SECTIONS, {
//   method: 'POST',
//   headers: { 'Content-Type': 'application/json' },
//   body: JSON.stringify(payloadToProxyHome)
// })
// .then(response => {
//   if (!response.ok) {
//     response.json().then(err => console.error('Error desde proxy GA (page_view):', err)).catch(() => console.error('Error desde proxy GA (Home page_view), respuesta no JSON'));
//   } else {
//     response.json().then(data => console.log('Éxito vía proxy GA (page_view):', data)).catch(() => console.log('Éxito vía proxy GA (Home page_view), respuesta no JSON'));
//   }
// })
// .catch(error => {
//   console.error('Error de red contactando proxy GA (page_view):', error);
// });

// ReactGA.send({ hitType: "pageview", page: "/pages/Home", page_title: "Inicio" });

const Home: React.FC = () => {
    //ReactGA.initialize('G-QMKE0236CC');
   

    const url = env.REACT_APP_URL;
    //require('dotenv').config()
    const token = localStorage.getItem('token');
    const header = {
        'Authorization': 'Bearer ' + token
    }


    const sos = async () => {
        const instance = axios.create({
            baseURL: url,
            headers: header
        })

        await instance.get('/api/sos/0')
            .then(res => {
                if (res.data.state === 'error') {
                    localStorage.removeItem('status');
                }

            })
    }


    const getFaqs = async () => {
        const instance = axios.create({
            baseURL: url,
            headers: header
        })

        await instance.get('/api/questions')
            .then(res => {
                localStorage.setItem('faqs', JSON.stringify(res.data.data))
            })
    }

    useEffect(() => {
        sos();
        getFaqs();
    }, []);


    // console.log(REACT_APP_URL.REACT_APP_URL)

    return (
        <IonPage>
            <Header pageName="Inicio" />
            <IonContent >
                <HomeSections />
            </IonContent>
            <Footer />
        </IonPage>
    );
}

export default Home;